// Feed audit page. The admin sidebar entry lives at `/admin/feed-audit`
// (see `features/admin/paths.ts`); these are the horizontal tabs INSIDE the page,
// one per audit, each its own child route and its own endpoint.
export const INCOMPLETE_PROJECTS_URL = 'incomplete'
export const EXPORTS_URL = 'exports'
export const VENDOR_DELIVERIES_URL = 'vendor-deliveries'
export const URL_SUBMISSIONS_URL = 'url-submissions'
export const RATINGS_ANOMALIES_URL = 'ratings-anomalies'
export const RATINGS_ANOMALY_DETAIL_SEGMENT = ':sourceUuid'
